<template>
  <BaseModal
    small
    :loading="isLoading"
    :heading="$t('marketing.email.test-email-modal.heading')"
    @close="$emit('close')"
    useForm
    @submit="submit"
  >
    <Flex direction="column">
      <BaseText>
        {{ $t('marketing.email.test-email-modal.info') }}
      </BaseText>
      <BaseInput
        v-model="email"
        :label="$t('global.email')"
        required
        v-test="'send-test-email'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('close')"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :loading="isLoading"
        submitForm
        v-test="'send-test-submit'"
      >
        {{ $t('global.actions.send') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { flash } from '@/helpers/ui';
import { useMarketingStore } from '../store';

export default defineComponent({
  emits: ['close'],
  setup() {
    const { isInvalid, isSubmitted } = storeToRefs(useMarketingStore());
    const { updateEmailTemplate, sendMarketingEmail } = useMarketingStore();
    return {
      isInvalid,
      isSubmitted,
      updateEmailTemplate,
      sendMarketingEmail,
    };
  },
  data() {
    return {
      email: '',
      isLoading: false,
    };
  },
  methods: {
    submit() {
      // besides checking for the modal validation it has to check the email validation
      this.isSubmitted = true;
      if (this.isInvalid) {
        return;
      }

      this.isLoading = true;

      if (this.$route.params.id) {
        this.updateEmailTemplate('MARKETING_CAMPAIGN').then(() =>
          this.sendTestEmail(),
        );
      } else {
        this.sendTestEmail();
      }
    },
    sendTestEmail() {
      this.sendMarketingEmail({ testEmail: this.email }).finally(() => {
        this.$emit('close');
        flash(this.$t('global.flash.email_sent'));
        this.isSubmitted = false;
        this.isLoading = false;
      });
    },
  },
});
</script>
